import { createAction } from '@reduxjs/toolkit';
import { type LexicalEditor } from 'lexical';

import type { LanguageEnum } from 'js/src/client';
import type { TranslatedEditorsType } from 'js/src/data/translated-editors/translated-editors-types';
import { TRANSLATED_EDITORS_ACTIONS } from 'js/src/data/translated-editors/translated-editors-types';

export const storeTranslatedEditors = createAction<TranslatedEditorsType, string>(
    TRANSLATED_EDITORS_ACTIONS.STORE_TRANSLATED_EDITORS,
);
export const storeTranslatedEditor = createAction<{
    sceneGroupId: string;
    editor: LexicalEditor;
    langCode: LanguageEnum;
    lexicalControlsItsOwnState: boolean;
}>(TRANSLATED_EDITORS_ACTIONS.STORE_TRANSLATED_EDITOR);
export const storeActiveTranslationSceneGroupId = createAction<{
    sceneGroupId: string;
}>(TRANSLATED_EDITORS_ACTIONS.STORE_ACTIVE_TRANSLATION_SCENE_GROUP_ID);
export const clearActiveTranslationSceneGroupId = createAction(
    TRANSLATED_EDITORS_ACTIONS.CLEAR_ACTIVE_TRANSLATION_SCENE_GROUP_ID,
);

export const removeTranslatedEditor = createAction<{
    sceneGroupId: string;
}>(TRANSLATED_EDITORS_ACTIONS.REMOVE_TRANSLATED_EDITOR);
